<template>
  <q-page> 
    <q-card>
      <q-card-title>
        {{title}}
      </q-card-title>
    <q-card-main>
      <div class="row" v-if="showUserSelection == true">
        <div class="col-6">
          <q-collapsible :label="personTitle" v-model="userOpend">   
            <q-tree
              :nodes="persons"
              node-key="Id"
              :tick-strategy="tickStrategy" 
              :ticked.sync="tickedPerson"
            />
          </q-collapsible>
        </div>
      </div>
      <div class="row">
        <div class="col-4" v-if="$route.params.repid == '11'">
              <q-select
                stack-label="Status"
                :options="orderStatusOptions"
                v-model="status"
              />
        </div>
      </div>
      <div class="row" v-if="showDateSelection">
        <div class="col">
          <q-btn class="button" @click="thisMonth()" color="primary" size="sm" :label="$t('global.ThisMonth')" />
        </div>
        <div class="col">
          <q-btn class="button" @click="previousMonth()" color="primary" size="sm" :label="$t('global.PreviousMonth')" />
        </div>
        <div class="col">
          <q-btn class="button" @click="nextMonth()" color="primary" size="sm" :label="$t('global.NextMonth')" />
        </div>
      </div>
      <div class="row" v-if="showDateSelection">
        <div class="col-5">
          <q-datetime v-model="dateFrom" type="date" :float-label="$t('global.DateFrom')" format="DD.MMM.YYYY"/>
        </div>
        <div class="col-1"></div>
        <div class="col-5">
          <q-datetime v-model="dateTo" type="date" :float-label="$t('global.DateTo')" format="DD.MMM.YYYY" />
        </div>
      </div>
      <img v-if="repLoaded == false" src="@/assets/load.gif">
      <div v-show="repLoaded" class="report">
        <iframe
         class="content-frame full-width "
          :src="repSource"
          frameborder="0"
          allowfullscreen
          @load="load"
          >
        </iframe>
      </div>
    </q-card-main>   
  </q-card>
  </q-page>
</template>
<script>
import { date } from 'quasar'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'Journal',
  data: function () {
    return {
      dateFrom: this.moment().startOf('year').toISOString(),
      dateTo:  this.moment().add(1, 'days').toISOString(),
      repLoaded: false,
      showDateSelection: true,
      showUserSelection: true,
      monthOffset: 0,
      userOpend: false,
      persons: [],
      tickStrategy: 'leaf',
      tickedPerson: [],
      personTreeFlat: [],
      form: {
        SessionId: null,
        action: 'GeoRegionsTree',
        IdLanguage: 1
      },
      status: 1,
      orderStatusOptions: [
        { label: this.$t('global.All'),   value: 1 },
        { label: this.$t('global.Open'),  value: 2 },
        { label: this.$t('global.Completed'),   value: 3 },
      ],
    }
  },
  methods: {
		load: function(){
      this.repLoaded = true
    },
    thisMonth(){
      this.dateFrom = this.moment().startOf('month').toISOString()
      this.dateTo =  this.moment().add('months', 1).date(1).subtract('days', 1).toISOString()
      this.monthOffset = 0
    },
    previousMonth(){
      this.monthOffset--
      this.dateFrom = this.moment().startOf('month').add('month', this.monthOffset).toISOString()
      this.dateTo = this.moment(this.dateFrom).endOf('month').toISOString()
    },
    nextMonth(){
      this.monthOffset++
      this.dateFrom = this.moment().startOf('month').add('month', this.monthOffset).toISOString()
      this.dateTo = this.moment(this.dateFrom).endOf('month').toISOString()
    },
    loadPersonTree(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "getPersonTree"
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              //this.propsExpanded.push(response.data[0].IdGeoRegion) //Open expand first node
              this.persons = response.data
              this.makePersonTreeFlat(response.data)
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },
    makePersonTreeFlat(elements){ 
      if(elements != null){
        elements.forEach(element => {
          if(element.IdUser != null){
            this.personTreeFlat[element.IdUser] = { Label: element.label }
          }
          //recursive call:
          this.makePersonTreeFlat(element.children)
        
        })
      }
    },
  },
  computed:{
      repSource () {
        var dFrom = date.formatDate(this.dateFrom, 'YYYY-MM-DD')   
        var dTo = date.formatDate(this.dateTo, 'YYYY-MM-DD')
        var pList = this.tickedPerson
        return this.$reportUrl + "/WorkTime.aspx?sid=" + this.$store.state.session.SessionId + "&dateFrom=" + 
          dFrom + "&dateTo=" + dTo +"&repid=" + this.$route.params.repid + "&locale=" + 
          this.$i18n.locale + "&plist=" + this.tickedPerson + "&status=" + this.status
      },

      personTitle(){
        var eCount = this.tickedPerson.length
        if (eCount == 0){
          return this.$t('global.All') + ' ' + this.$t('global.Employees')
        }
        if(eCount == 1){
          return  '1 ' + this.$t('global.Employee') 
        }
        return eCount + ' ' + this.$t('global.Employees') 
      },

      title(){
        this.showDateSelection = true
        this.showUserSelection = true
        var repId = this.$route.params.repid
        if(repId == 6){
          this.showDateSelection = false
          this.showUserSelection = false
          return this.$t('global.ResourceTemplateList')
        }
        if(repId == 7)
          return this.$t('global.WorkReport')

        if(repId == 8)
          return this.$t('global.ResourceReport')

        if(repId == 10)
          return this.$t('global.CostBill')

        if(repId == 11){
          this.showUserSelection = false
          return this.$t('global.OrderJournal')
        }


        return this.$t('global.WorkingHours')
      }

  },
  created () {
    this.loadPersonTree()
  },
  watch: {
    repSource: function (val) {
      this.repLoaded = false
    },
  }
}
</script>
<style scoped>
.content-frame{
  height: calc(100vh - 255px);
  width: 100%;
}
</style>

